export const augmentedRealityMediaLimit = 1;
